import { render, staticRenderFns } from "./color-chart.vue?vue&type=template&id=29789c30"
import script from "./color-chart.vue?vue&type=script&lang=js"
export * from "./color-chart.vue?vue&type=script&lang=js"
import style0 from "./color-chart.vue?vue&type=style&index=0&id=29789c30&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports